<template>
  <div class="content">
    <div class="content-header">
      <div class="content-header-box">
        <div class="header-left">
          <div class="header-icon">
            <img  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTM0NjNFNUNGNjM2MTFFOEJBMDQ4QUVGQzI5NDMzN0MiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTM0NjNFNURGNjM2MTFFOEJBMDQ4QUVGQzI5NDMzN0MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxMzQ2M0U1QUY2MzYxMUU4QkEwNDhBRUZDMjk0MzM3QyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxMzQ2M0U1QkY2MzYxMUU4QkEwNDhBRUZDMjk0MzM3QyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PpwPTVgAAAB2SURBVHjaYvr///++/5SBfUwMDAxGDJQBAxYgYQHF5IKTIENuQDHZgImBCoAqhoC8ww/EihSYcR9kyAUgVqDAkAcg7/yj0Df/QC4xAGJlCgy5BzLkM9RLwySK1YDYigIzjoMMOQrEIhQY8hbknbMU+uYkQIABAFS6UwgvbSfaAAAAAElFTkSuQmCC" style="height: 13px;" />
          </div>
          <div class="header-tit"><span class="tit-a">IOTDCS</span><span class="tit-b">|</span><span class="tit-c">视图</span></div>
        </div>
        <div class="header-right">
          <el-dropdown size="small" placement="top-end"> 
           <div class="hearde-right-icon-1"></div>
           <el-dropdown-menu slot="dropdown">
                <div>
                    <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                      交通信号界面
                    </el-dropdown-item>
                  </div>
                  <div>
                    <el-dropdown-item icon="el-icon-s-marketing" class="clearfix">
                    太阳能界面
                    </el-dropdown-item>
                  </div>
           </el-dropdown-menu>
          </el-dropdown>
           <div class="hearde-right-icon-tit">视图</div>
           <div class="hearde-right-icon-2"></div>
           <div class="hearde-right-icon-tit">{{username}}</div>
           <div @click="goback" class="hearde-right-icon-3"></div>
        </div>
      </div>
    </div>
    <div class="content-body">
      <div class="content-body-box">
        <div class="content-body-menu">
          <div class="menu-box" v-for="(item,index) in menuArray" :key="index">
          {{item}}
          </div>
        </div>
        <div class="content-body-box-main">
          <div class="content-box-main-solar">
            <div class="line1" :class="{action:showLine}"></div>
            <div class="line2" :class="{action:showLine}"></div>
            <div class="line3" :class="{action:showLine}"></div>
            <div class="line4" :class="{action:showLine}"></div>
            <div class="line5" :class="{action:showLine}"></div>
            <div class="line6" :class="{action:showLine}"></div>
            <div class="line7" :class="{action:showLine}"></div>
            <div class="line8" :class="{action:showLine}"></div>
            <div class="line9" :class="{action:showLine}"></div>
            <div class="line10" :class="{action:showLine}"></div>
            <div class="line11" :class="{action:showLine}"></div>
            <div class="line12" :class="{action:showLine}"></div>
            <div class="line13" :class="{action:showLine}"></div>
            <div class="line14" :class="{action:showLine}"></div>
            <div class="line15" :class="{action:showLine}"></div>
            <div class="line16" :class="{action:showLine}"></div>
            <div class="line17" :class="{action:showLine}"></div>
            <div class="line18" :class="{action:showLine}"></div>
            <div class="line19" :class="{action:showLine}"></div>
            <div class="line20" :class="{action:showLine}"></div>
            <div class="line21" :class="{action:showLine}"></div>
            <div class="line22" :class="{action:showLine}"></div>
            <div class="line23" :class="{action:showLine}"></div>
            <div class="line24" :class="{action:showLine}"></div>
            <div class="line25" >
              <div class="bar"></div>
            </div>
            <div class="line-data-1">
                  {{temp1}}℃
            </div>
            <div class="line-data-2">
                  {{temp2}}℃
            </div>
            <div class="line-data-3">
                  {{temp3}}℃
            </div>
            <div class="line-data-4">
                  50%
            </div>
          </div>
        </div>
      </div>
     
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import service from '../../service/leftService.js'
  export default {
    name:'',
    props:[''],
    data () {
      return {
        temp1: '0.00',
        temp2: '0.00',
        temp3: '0.00',
        showLine:true,
        username:localStorage.getItem('username'),
        timmer: null,
        menuArray:['项目概况','在线监测','故障报警','设备管理','精准节能','能耗KPI','现场视频']
      };
    },

    components: {},

    computed: {},

    beforeMount() {},

  mounted() {
    this.timmer = setInterval(() => {
      this.getPublicData()
    }, 1000)
    },
  methods: {
    switchBtn() {
      this.showLine = !this.showLine
    },
    // 南北向红绿灯数据
    getPublicData() {
      let obj = {
        "args": ['太阳能数据接口']
      }
      service.getPublicData(obj).then(res => {
        for (let a of res) {
          a.name == 'T_PT100_T1' ? this.temp1 = a.value : ''
          a.name == 'T_PT100_T2' ? this.temp2 = a.value : ''
          a.name == 'T_PT100_T3' ? this.temp3 = a.value :''
       }
      })
    },
 
    // 返回上一页
    goback() {
      this.$router.go(-1)
    }
    },
  destroyed() {
    clearInterval(this.timmer)
  },
  beforeDestroy() {
    clearInterval(this.timmer)
  },
  watch: {

    }
  }

</script>
<style  scoped>
.content{
  width: 100%;
  height: 100%;
  background-image: url('../../../static/img/lengdongzhan/back4.png');
  position: relative;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-size: 100% 100%;
}
.content-header{
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 40px;
  background-color: #525659;
  border-bottom: 1px solid rgb(37, 37, 37);
}
.content-body{
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 40px;
}
.content-body-box{
  width: 100%;
  height: 100%;
  display: flex;
}
.content-body-menu{
  width: 200px;
  height: 100%;
  background-color: #525659d2;
  overflow: hidden;
}
.content-body-box-main{
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
}
.content-box-main-solar{
  width: 1700px;
  height: 900px;
  position: relative;
  background-image: url('../../../static/img/lengdongzhan/back3.png');
}
.menu-box{
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #2f3030;
  color: #fff;
}
.menu-box:hover{
  background-color: #2f3030;
  cursor: pointer;
}
.icon{
  width: 19px;
  height: 56px;
  background-size: 100% 100%;
  position: absolute;
}
.go{
  width: 60px;
  height: 25px;
  background-size: 100% 100%;
  position: absolute;
}
.content-header-box{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-left: 15px;
  padding-right: 15px;
  justify-content: space-between;
  align-items: center;
  display: flex;
}

.header-left{
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-icon{ 
margin-right: 30px;
margin-top: 4px;
}
.header-tit{
  color: #fff;
  font-size: 15px;
  font-weight: 700;
}
.tit-a{
  margin-right: 5px;
}
.tit-b{
  margin-right: 5px;
  font-size: 18px;
}

.header-right{
  display: flex;
  justify-content: center;
  align-items: center;
}
.hearde-right-icon-1{
  width: 23px;
  height: 23px;
  background-image: url('../../assets/keshihua.png');
  background-size: 100% 100%;
  margin-right: 8px;
  cursor: pointer;
}
.hearde-right-icon-tit{
   color: #fff;
   font-size: 13px;
   margin-right: 20px;
}

.hearde-right-icon-2{
  width: 21px;
  height: 21px;
  background-image: url('../../assets/user.png');
  background-size: 100% 100%;
  margin-right: 10px;
  cursor: pointer;
}
.hearde-right-icon-3{
  width: 20px;
  height: 20px;
  background-image: url('../../assets/退出.png');
  background-size: 100% 100%;
  margin-right: 10px;
  cursor: pointer;
}
.con{
  width: 624px;
  height: 624px;
  background-image: url('../../../static/img/lengdongzhan/center.png');
  position: relative;
  overflow: hidden;
}
@keyframes move2 {
  from {
  }
  to {
    background-position: 0 -12px, 100% 12px, 12px 0, -12px 100%;
  }
}
.action{
  background-position: 0 0, 100% 0, 0 0, 0 100%;
  animation: move2 0.2s infinite linear;
}
.line1{
  width: 510px;
  position: absolute;
  height: 13px;
  left: 153px;
  top: 749px;
  border-radius: 5px;
  transform: rotate(0deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(255, 123, 7, 0.573) 0) repeat-x;
  background-size: 13px 12px, 13px 12px, 12px 13px, 12px 13px;
}
.line2{
  width: 318px;
  position: absolute;
  height: 13px;
  left: 0px;
  top: 597px;
  border-radius: 5px;
  transform: rotate(90deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(255, 123, 7, 0.573) 0) repeat-x;
  background-size: 13px 12px, 13px 12px, 12px 13px, 12px 13px;
}
.line3{
  width: 853px;
  position: absolute;
  height: 13px;
  left: 153px;
  top: 445px;
  border-radius: 5px;
  transform: rotate(180deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(255, 123, 7, 0.573) 0) repeat-x;
  background-size: 13px 12px, 13px 12px, 12px 13px, 12px 13px;
}

.line4{
  width: 190px;
  position: absolute;
  height: 8px;
  left: 195px;
  top: 358px;
  transform: rotate(90deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(255, 123, 7, 0.573) 0) repeat-x;
  background-size: 8px 12px, 8px 12px, 12px 8px, 12px 8px;
}
.line5{
  width: 190px;
  position: absolute;
  height: 8px;
  left: 372px;
  top: 358px;
  transform: rotate(90deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(255, 123, 7, 0.573) 0) repeat-x;
  background-size: 8px 12px, 8px 12px, 12px 8px, 12px 8px;
}
.line6{
  width: 190px;
  position: absolute;
  height: 8px;
  left: 550px;
  top: 358px;
  transform: rotate(90deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(255, 123, 7, 0.573) 0) repeat-x;
  background-size: 8px 12px, 8px 12px, 12px 8px, 12px 8px;
}
.line7{
  width: 190px;
  position: absolute;
  height: 8px;
  left: 728px;
  top: 358px;
  transform: rotate(90deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(255, 123, 7, 0.573) 0) repeat-x;
  background-size: 8px 12px, 8px 12px, 12px 8px, 12px 8px;
}
.line8{
  width: 190px;
  position: absolute;
  height: 8px;
  left: 907px;
  top: 358px;
  transform: rotate(90deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(255, 123, 7, 0.573) 0) repeat-x;
  background-size: 8px 12px, 8px 12px, 12px 8px, 12px 8px;
}
.line9{
  width: 130px;
  position: absolute;
  height: 8px;
  left: 110px;
  top: 115px;
  transform: rotate(90deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgb(255, 123, 7) 0) repeat-x;
  background-size: 8px 12px, 8px 12px, 12px 8px, 12px 8px;
}
.line10{
  width: 130px;
  position: absolute;
  height: 8px;
  left: 289px;
  top: 115px;
  transform: rotate(90deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgb(255, 123, 7) 0) repeat-x;
  background-size: 8px 12px, 8px 12px, 12px 8px, 12px 8px;
}
.line11{
  width: 130px;
  position: absolute;
  height: 8px;
  left: 465px;
  top: 115px;
  transform: rotate(90deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgb(255, 123, 7) 0) repeat-x;
  background-size: 8px 12px, 8px 12px, 12px 8px, 12px 8px;
}
.line12{
  width: 130px;
  position: absolute;
  height: 8px;
  left: 644px;
  top: 115px;
  transform: rotate(90deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgb(255, 123, 7) 0) repeat-x;
  background-size: 8px 12px, 8px 12px, 12px 8px, 12px 8px;
}
.line13{
  width: 130px;
  position: absolute;
  height: 8px;
  left: 822px;
  top: 115px;
  transform: rotate(90deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgb(255, 123, 7) 0) repeat-x;
  background-size: 8px 12px, 8px 12px, 12px 8px, 12px 8px;
}
.line14{
  width: 933px;
  position: absolute;
  height: 13px;
  left: 170px;
  top: 53px;
  border-radius: 5px;
  transform: rotate(180deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgb(255, 123, 7) 0) repeat-x;
  background-size: 13px 12px, 13px 12px, 12px 13px, 12px 13px;
}
.line15{
  width: 520px;
  position: absolute;
  height: 13px;
  left: 838px;
  top: 307px;
  border-radius: 5px;
  transform: rotate(270deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgb(255, 123, 7) 0) repeat-x;
  background-size: 13px 12px, 13px 12px, 12px 13px, 12px 13px;
}
.line16{
  width: 33px;
  position: absolute;
  height: 13px;
  left: 1092px;
  top: 560px;
  transform: rotate(180deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgb(255, 119, 0) 0) repeat-x;
  background-size: 13px 12px, 13px 12px, 12px 13px, 12px 13px;
}
.line17{
  width: 115px;
  position: absolute;
  height: 13px;
  left: 1010px;
  top: 690px;
  transform: rotate(0deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(255, 123, 7, 0.573) 0) repeat-x;
  background-size: 13px 12px, 13px 12px, 12px 13px, 12px 13px;
}
.line18{
  width: 150px;
  position: absolute;
  height: 13px;
  left: 765px;
  top: 750px;
  transform: rotate(0deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(255, 123, 7, 0.573) 0) repeat-x;
  background-size: 13px 12px, 13px 12px, 12px 13px, 12px 13px;
}
.line19{
  width: 53px;
  position: absolute;
  height: 13px;
  left: 1233px;
  top: 458px;
  transform: rotate(90deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(255, 255, 255, 0.612) 0) repeat-x;
  background-size: 13px 12px, 13px 12px, 12px 13px, 12px 13px;
}
.line20{
  width: 207px;
  position: absolute;
  height: 13px;
  left: 1253px;
  top: 435px;
  border-radius: 5px;
  transform: rotate(180deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(255, 255, 255, 0.612) 0) repeat-x;
  background-size: 13px 12px, 13px 12px, 12px 13px, 12px 13px;
}
.line21{
  width: 107px;
  position: absolute;
  height: 13px;
  left: 1511px;
  top: 435px;
  transform: rotate(180deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(255, 255, 255, 0.612) 0) repeat-x;
  background-size: 13px 12px, 13px 12px, 12px 13px, 12px 13px;
}
.line22{
  width: 67px;
  position: absolute;
  height: 13px;
  left: 1193px;
  top: 795px;
  transform: rotate(90deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(9, 172, 254, 0.612) 0) repeat-x;
  background-size: 13px 12px, 13px 12px, 12px 13px, 12px 13px;
}
.line23{
  width: 120px;
  position: absolute;
  height: 13px;
  left: 1220px;
  top: 822px;
  border-radius: 5px;
  transform: rotate(0deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(9, 172, 254, 0.612) 0) repeat-x;
  background-size: 13px 12px, 13px 12px, 12px 13px, 12px 13px;
}
.line24{
  width: 120px;
  position: absolute;
  height: 13px;
  left: 1435px;
  top: 805px;
  transform: rotate(0deg);
  border-top: 1px solid #5353539c;
  border-bottom: 1px solid #5353539c;
  background: linear-gradient(0deg, transparent 6px, transparent 6px) repeat-y,
    linear-gradient(0deg, transparent 50%, transparent 0) repeat-y,
    linear-gradient(90deg, transparent 50%, transparent 0) repeat-x,
    linear-gradient(90deg, transparent 50%, rgba(9, 172, 254, 0.612) 0) repeat-x;
  background-size: 13px 12px, 13px 12px, 12px 13px, 12px 13px;
}
.line25{
  width: 10px;
  position: absolute;
  height: 220px;
  left: 1200px;
  bottom: 160px;
  background-color: rgb(0, 137, 249);
}
.bar{
  width: 100%;
  height: 50%;
  position: absolute;
  background-color: rgb(238, 255, 4);
  bottom: 0;
}
.line-data-1{
  position: absolute;
  left: 930px;
  top: 100px;
  font-size: 15px;
  color: rgb(99, 248, 0);
}
.line-data-2{
  position: absolute;
  left: 1080px;
  top: 760px;
  font-size: 15px;
  color: rgb(99, 248, 0);
}
.line-data-3{
  position: absolute;
  left: 1320px;
  top: 500px;
  font-size: 15px;
  color: rgb(99, 248, 0);
}
.line-data-4{
  position: absolute;
  left: 1220px;
  top: 650px;
  font-size: 15px;
  color: rgb(245, 225, 2);
}
/* 

*/
</style>


// WEBPACK FOOTER //
// src/components/graphically/solarEnergyBigShow.vue